import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-message-popup',
  templateUrl: './message-popup.component.html',
  styleUrls: ['./message-popup.component.css']
})
export class MessagePopupComponent implements OnInit {

  title: string;
  message: string;
  options: string[];
  answer: string = "";

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

  respond(answer: string) {
    this.answer = answer;
    this.bsModalRef.hide();
  }
}
